// src/routes/ProtectedRoute.jsx
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useStore from '../store/index';

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { accessToken } = useStore();

  useEffect(() => {
    console.log('protected route accessToken', accessToken);
    if (!accessToken) {
      // Save current path so user returns after login
      navigate('/login', { 
        replace: true,
        state: { from: location.pathname }
      });
    }
  }, [accessToken, navigate, location]);

  // Render nothing while redirecting
  if (!accessToken) return null;

  // Token exists → render the page
  return children;
};

export default ProtectedRoute;